// @ts-nocheck
import { Dictionary } from "@insite/client-framework/Common/Types";
import { createContext, Dispatch, SetStateAction, useContext } from "react";

export interface RmaRestockFee {
    amount: string;
    checked: boolean;
}

export interface RmaRestockFeeHandlers {
    addOrUpdate: (id: string | number, amount: string, checked?: boolean) => void;
    remove: (id: string | number) => void;
    change: (id: string | number, checked?: boolean) => void;
    changeAll: (checked: boolean) => void;
}

export type RmaRestockFees = Dictionary<RmaRestockFee>;

export interface RmaContextModel {
    isSubmitting: boolean;
    isSuccess: boolean;
    restockFeeHandlers: RmaRestockFeeHandlers;
    restockFees: Dictionary<RmaRestockFee>;
    setIsSubmitting: Dispatch<SetStateAction<boolean>>;
    setIsSuccess: Dispatch<SetStateAction<boolean>>;
}

export const RmaContext = createContext<RmaContextModel>({} as any);
export const useRmaContext = () => useContext(RmaContext);
